export interface WireFrameExtractDialogOptions {
    figure: {
        id: string;
        getUrl: () => string;
        s3Key: string;
        imageWithAnnotations: string;
    };
    title?: string;
}

export interface WireFrameExtractDialogResult {
    action: WireFrameExtractDialogAction;
    originalFigureId: string;
    wireframeS3Key: string;
}

export enum WireFrameExtractDialogAction {
    SAVE_AS = 'SAVE_AS',
    REPLACE = 'REPLACE',
    DISCARD = 'DISCARD',
}
